import { EventConvertHook } from './event.convert.hook'
import { ClientRepresentedEvent, ServerRepresentedEvent } from './event.model'
/**
 * Converts the social media links for an event
 */
export class LinksConvertHook extends EventConvertHook {
  /** Prefixes for social media schemes */
  private urlPrefixes = {
    facebookAccount: 'https://www.facebook.com/',
    twitter_account: 'https://www.twitter.com/',
    instagramAccount: 'https://www.instagram.com/',
    linkedin_account: 'https://www.linkedin.com/',
    snapchat_account: 'https://www.snapchat.com/',
    youtube_account: 'https://www.youtube.com/',
    messenger_account: 'https://m.me/',
    website: 'https://',
    map_direct_link: ''
  }

  /**
   * prefixes keys
   */
  private prefixes = Object.keys(this.urlPrefixes)

  /** combines a url with a prefix */
  private updateUrl(url: string, base: string) {
    return base + url
  }
  /** removes a prefix from a url */
  private removeUrl(url: string, base: string) {
    return url.replace(base, '')
  }
  /**
   * Removes empty social media properties
   * Updates urls with it's prefixes
   * @param event client event
   * @returns client event
   */
  beforeConvertingToServerRepresentedEvent(event: ClientRepresentedEvent): ClientRepresentedEvent {
    Object.keys(event.social_media).forEach((key) => {
      if (!event.social_media[key]) {
        delete event.social_media[key]
        return
      }
      if (this.prefixes.includes(key)) {
        event.social_media[key] = this.updateUrl(event.social_media[key], this.urlPrefixes[key])
      }
    })
    return event
  }
  /**
   * stub
   * @param event server event
   * @returns server event
   */
  afterConvertingToServerRepresentedEvent(event: ServerRepresentedEvent): ServerRepresentedEvent {
    return event
  }
  /**
   * creates the social media object as a fallback for older events
   * removes the prefixes for editing
   * @param event server event
   * @returns server event
   */
  beforeConvertingToClientRepresentedEvent(event: ServerRepresentedEvent): ServerRepresentedEvent {
    if (!event.social_media) {
      event.social_media = {}
    }
    Object.keys(event.social_media).forEach((key) => {
      if (!event.social_media[key]) {
        event.social_media[key] = ''
        return
      }
      if (this.prefixes.includes(key)) {
        event.social_media[key] = this.removeUrl(event.social_media[key], this.urlPrefixes[key])
      }
    })
    return event
  }
  /**
   * stub
   * @param event client event
   * @returns client event
   */
  afterConvertingToClientRepresentedEvent(event: ClientRepresentedEvent): ClientRepresentedEvent {
    return event
  }

  /** Applies https protocol
   * @deprecated
   */
  private applyProtocol(url: string) {
    return !/^(?:f|ht)tps?:\/\//.test(url) ? 'https://' + url : url
  }
}
